import React from 'react';

export const RequiredLabel = ({ color, error }) =>  {
   return (
       <div
           className={`required-block ${error ? 'required-error' : ''}`}
           style={{ color }}
       >
           <span className="required-asterix">*</span>
           <span>Required</span>
       </div>
   )
};
